import type { BranchMinimumCartSystemValueType } from '../enums/BranchMinimumCartSystemValueType'

export class BranchMinimumCartSystemMiniEntity {
  id?: number
  name?: string | null
  isDefault?: boolean
  valueType?: BranchMinimumCartSystemValueType
}
